export default __webpack_public_path__ + "static/media/success.1f3654f4.svg";